import React, { useState } from "react";
import { Button, Dialog, Classes, Label, InputGroup } from "@blueprintjs/core";
import formFieldHelper from "../../form/formFieldHelper";
import formErrorHelper from "../../form/formErrorHelper";
import { useError } from "../../common/components/Errors";
import api from "../../common/lib/api";

export default function ChangePassword(token) {
  const [show, setShow] = useState(false);
  const { errors, setErrors } = useError();
  const [state, setState] = useState({
    currentPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  });

  const formField = formFieldHelper(state, setState);
  const formError = formErrorHelper(errors);

  async function submit() {
    setErrors([]);
    const { data } = await api.post("/change-password", state, {
      validateStatus: () => true,
    });
    if (data.errors) {
      setErrors(data.errors);
      return;
    }
    alert('Password changed');
    setShow(false);
  }

  if (show) {
    return (
      <Dialog isOpen title="Change Password" onClose={() => setShow(false)}>
        <form
          onSubmit={(e) => {
            submit(e.preventDefault());
          }}
        >
          <div className={Classes.DIALOG_BODY}>
            <Label>
              Old Password
              <InputGroup
                placeholder="Enter your current password..."
                type="password"
                required
                {...formField("currentPassword")}
              />
              {formError("currentPassword")}
            </Label>
            <Label>
              New Password
              <InputGroup
                placeholder="Enter your new password..."
                type="password"
                required
                {...formField("newPassword")}
              />
              {formError("newPassword")}
            </Label>
            <Label>
              Confirm New Password
              <InputGroup
                placeholder="Enter your new password again..."
                type="password"
                required
                {...formField("confirmNewPassword")}
              />
              {formError("confirmNewPassword")}
            </Label>
            <Button type="submit">Change Password</Button>
          </div>
        </form>
      </Dialog>
    );
  }
  return <Button onClick={() => setShow(true)}>Change Password</Button>;
}
